import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'delayed-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DelayedProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'company',
      'projectPlacement.address',
      'delayedReason',
      'productType',
      'displayStatus',
      'star'
    ];
  }

  protected getLocalStorageKey(): string {
    return 'DelayedProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'status/Uitgesteld';
  }

  public getPageTitle(): string {
    return 'Uitgesteld';
  }
}
